import { mapActions, mapGetters, mapState } from 'vuex'

export const SmartFormClickMixin = {
  computed: {
    ...mapState(['isUnitaryTest']),
    ...mapGetters(['isSinglePaymentButton', 'isSmartFormOpen'])
  },
  methods: {
    ...mapActions(['safeIntercept', 'createApplePaySession']),
    async interruptsExecution(paymentMethod, action, formId = null) {
      // For Apple Pay, create the session initially. See KJS-3770
      if (paymentMethod === 'APPLE_PAY') this.createApplePaySession()
      // Intercept callback
      this.prepareFocusOnClosure()
      return await this.safeIntercept({
        name: 'onSmartFormClick',
        args: [{ paymentMethod, action, formId }]
      })
    },
    /**
     * Set the focus back to the payment button once popin is closed.
     *
     * @since KJS-3902
     * @see KJS-5387 Wait next tick after closure before trying focus as the
     *  button is expected to be disabled while popin is open.
     */
    async prepareFocusOnClosure() {
      const waitPopinState = expectedState => {
        return new Promise(resolve => {
          const unwatch = this.$watch('isSmartFormOpen', async isOpen => {
            if (isOpen !== expectedState) return
            resolve()
            unwatch()
          })
        })
      }
      await waitPopinState(true)
      await waitPopinState(false)
      this.$nextTick(() => {
        if (typeof this.$el?.focus === 'function') this.$el.focus()
      })
    }
  }
}
